export default __webpack_public_path__ + "static/media/mypartner-sprite-834f579efbdbbea85cd9b21c45789f2c.png";